import React from 'react';

const ProgressBar = ({ percentage }) => {
    // Ensure the percentage is between 0 and 100
    const clampedPercentage = Math.min(100, Math.max(0, percentage));

    // Determine the color class based on the percentage
    // For example: < 30% = low, 30-70% = medium, > 70% = high
    let colorClass = 'low';
    if (clampedPercentage >= 80) {
        colorClass = 'high';
    } else if (clampedPercentage >= 50) {
        colorClass = 'medium';
    }

    return (
        <div className="progress-bar">
            <div
                className={`progress-bar__fill ${colorClass}`}
                style={{ width: `${clampedPercentage}%` }}  // Only width is dynamically set inline
            />
        </div>
    );
};

export default ProgressBar;
